import { call, put, takeLatest } from 'redux-saga/effects'

// redux
import * as opportunitiesApi from '../apiModules/opportunities'
import * as opportunitiesModule from '../modules/opportunities'

// utils
import isLoggedIn from 'utils/auth'
import UrlBuilder from 'utils/urlBuilder'
import logError from 'utils/logger'

// config
import l from 'config/localization'
import constants from 'config/constants'

function* fetchOpportunities({ payload }) {
  try {
    const response = yield call(opportunitiesApi.fetchOpportunities, payload)
    yield put(opportunitiesModule.fetchSuccess(response))
  } catch (err) {
    yield put(opportunitiesModule.fetchFailure(err))
  }
}

function* fetchOwnOpportunities({ payload }) {
  try {
    const response = yield call(opportunitiesApi.fetchOwnOpportunities, payload)
    yield put(opportunitiesModule.fetchSuccess(response))
  } catch (err) {
    yield put(opportunitiesModule.fetchFailure(err))
  }
}

function* fetchOpportunity({ payload }) {
  try {
    const response = yield call(opportunitiesApi.fetchOpportunity, payload)
    yield put(opportunitiesModule.singleFetchSuccess(response))
  } catch (err) {
    if (err.response.status === 403) {
      if (!isLoggedIn()) {
        const { navigate } = payload
        return navigate(
          `/login?redirectingToPvt=true&redirectTo=/${l('ROUTE_OPPS')}/${payload.opportunityId}`
        )
      }

      yield put(
        opportunitiesModule.singleFetchFailure({
          hasError: true,
          errorCode: '403'
        })
      )
    } else if (err.response.status === 404) {
      yield put(
        opportunitiesModule.singleFetchFailure({
          hasError: true,
          errorCode: '404'
        })
      )
    } else {
      yield put(opportunitiesModule.singleFetchFailure(err))
    }
  }
}

function* fetchOppForAdmin({ payload }) {
  try {
    const response = yield call(opportunitiesApi.fetchOppForAdmin, payload)
    yield put(opportunitiesModule.singleFetchSuccess(response))
  } catch (err) {
    yield put(opportunitiesModule.singleFetchFailure(err.response.status))
  }
}

function* fetchByLocation({ payload }) {
  const page = 1
  try {
    const response = yield call(opportunitiesApi.fetchByLocation, payload, page)
    yield put(opportunitiesModule.fetchSuccess(response))
  } catch (err) {
    logError(err)
  }
}

function* createOpportunity({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(key => {
      if (payload[key] && key !== 'navigate') {
        formDataVals.append(key, payload[key])
      }
    })

    const { data } = yield call(opportunitiesApi.createOpportunity, formDataVals)
    yield put(opportunitiesModule.createSuccess({ data }))

    const redirectPath =
      payload.goal_type === constants.OPPORTUNITY_GOAL_TYPES.GS_WORKSHOP ? 'workshops' : 'rounds'
    const { navigate } = payload
    yield navigate(`/dashboard/${redirectPath}`)
  } catch (err) {
    const errorMessage = err.response.data
    yield put(opportunitiesModule.createFailure({ errorMessage, data: payload }))
  }
}

function* updateOpportunity({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(key => {
      if (payload[key] && key !== 'navigate') {
        formDataVals.append(key, payload[key])
      }
    })

    const updatedOpportunity = yield call(opportunitiesApi.updateOpportunity, formDataVals)
    yield put(opportunitiesModule.updateSuccess(updatedOpportunity))

    const redirectPath =
      payload.goal_type === constants.OPPORTUNITY_GOAL_TYPES.GS_WORKSHOP ? 'workshops' : 'rounds'

    const { navigate } = payload
    yield navigate(`/dashboard/${redirectPath}`)
  } catch (err) {
    yield put(opportunitiesModule.updateFailure())
  }
}

function* deleteOpportunity({ payload }) {
  try {
    yield call(opportunitiesApi.deleteOpportunity, payload)
    yield put(opportunitiesModule.deleteSuccess(payload))
    UrlBuilder.displayDeleteSuccessMessage()
  } catch (err) {
    yield put(opportunitiesModule.deleteFailure())
  }
}

export const opportunitiesSagas = [
  takeLatest(opportunitiesModule.FETCH_OPPORTUNITIES, fetchOpportunities),
  takeLatest(opportunitiesModule.FETCH_OWN_OPPORTUNITIES, fetchOwnOpportunities),
  takeLatest(opportunitiesModule.FETCH_OPPORTUNITY, fetchOpportunity),
  takeLatest(opportunitiesModule.FETCH_OPP_FOR_ADMIN, fetchOppForAdmin),
  takeLatest(opportunitiesModule.CREATE_OPPORTUNITY, createOpportunity),
  takeLatest(opportunitiesModule.DELETE_OPPORTUNITY, deleteOpportunity),
  takeLatest(opportunitiesModule.UPDATE_OPPORTUNITY, updateOpportunity),
  takeLatest(opportunitiesModule.FETCH_BY_LOCATION, fetchByLocation)
]
